export default {
    test: "Bonjour le monde",
    loading: 'Chargement...',
    from_prepop_get_loan: 'Continuez avec votre demande pour obtenir votre prêt',
    you_were_referred_by: 'Vous avez été référé par',
    components: {
        form: {},
        field: {},
        smsverification: {
            edit_phone: "Modifier le numéro de téléphone",
            verify_code: "Vérifier",
            verified_success: 'Votre numéro de téléphone a été vérifié avec succès !',
            max_attempts_reached: 'Vous avez atteint le nombre maximum de tentatives.',
            verification_code_sent: 'Vous recevrez un code de vérification par SMS, des frais de messagerie ou de données standard peuvent s\'appliquer.',
            new_accounts_must_verify: 'Pour des raisons de sécurité, les nouveaux comptes doivent vérifier leurs numéros de téléphone.',
            last_attempt: 'Il vous reste 1 tentative.',
            sent_sms_to: 'Code SMS envoyé à :',
            resend_code: 'Demander un autre code',
            resend_code_in: 'Vous pouvez demander un autre code dans',
            seconds: 'secondes',
            skip_verification_car_loan: `<small><b class='text-primary'>Important:</b> Vous pouvez sauter cette étape, mais vos options peuvent être limitées.</small>`,
            skip_verification_account_creation: `<small><b class='text-primary'>Important:</b> Vous pouvez sauter cette étape en appuyant sur le bouton ci-dessous, mais vous ne pourrez pas créer de compte.</small>`,
            enter_valid_code: "Veuillez entrer un code de vérification valide.",
            enter_valid_phone: "Veuillez entrer un numéro de téléphone canadien valide.",
            sms_code_could_not_send: "Nous n'avons pas pu envoyer le code SMS au numéro fourni. Veuillez vérifier qu'il est correct et réessayez.",
            sms_code_is_incorrect: "Le code que vous avez fourni est incorrect. Veuillez réessayer.",
            enter_phone: 'Entrez votre numéro de téléphone',
            enter_code: "Entrez le code de vérification",
        }
    },
    validations: {
        invalid_data: "Données invalides fournies",
        postal_code_format: "Le code postal doit être au format A9A9A9",
        required_field: "Ce champ est requis",
        email_required: "Un courriel valide est requis",
        phone_format: "Le numéro de téléphone doit comporter 10 chiffres (sans espaces ni tirets)",
        phone_canadian: "Un numéro de téléphone canadien valide est requis (10 chiffres, sans espaces ni tirets)",
        password: "Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un chiffre.",
        password_confirmation: "Les mots de passe ne correspondent pas.",
        email_confirmation: 'Les courriels ne correspondent pas.',
        name: "Seuls les caractères alphabétiques sont autorisés",
        dob: "La date de naissance doit être au format AAAA-MM-JJ",
        date: "La date doit être au format AAAA-MM-JJ",
        sin: "Le NAS doit comporter 9 chiffres (sans espaces ni tirets)",
        invalid_character: "Caractère invalide",
        numeric: "Seuls les chiffres sont autorisés",
        drivers_license: "Vous devez avoir 18 ans ou plus et posséder un permis de conduire pour pouvoir obtenir un prêt automobile",
        address_required: "L'adresse est requise"
    },
    steps: {
        titles: {
            requested_amount: "Combien souhaitez-vous emprunter ?",
            requested_amount_debt: 'De combien avez-vous besoin pour consolider vos dettes ?',
            product_purpose: "Quel est le but du prêt ?",
            cc_debt_amount: "Montant de la dette sur carte de crédit",
            unsecured_debt_amount: "Montant total des autres dettes non garanties",
            in_credit_situation: "Quel est votre score de crédit estimé ?",
            income_type: "Sélectionnez votre principale source de revenus",
            income_type_other: "Avez-vous d'autres sources de revenus? <br><small>Cochez tout ce qui s'applique</small>",
            direct_deposit: "Recevez-vous votre revenu par dépôt direct ?",
            monthly_income: "Sélectionnez votre revenu mensuel",
            monthly_income_input: "Entrez votre revenu mensuel",
            monthly_other_income_input: "Entrez votre revenu mensuel",
            address: "Quelle est votre adresse ?",
            address_length_months: "Depuis combien de temps êtes-vous à cette adresse ?",
            address_length_months_current: "Depuis combien de temps êtes-vous à votre adresse actuelle ?",
            own_home: "Êtes-vous propriétaire ?",
            living_situation: "Parlez-nous de votre situation de logement",
            dob: "Quelle est votre date de naissance ?",
            employer_information: "Veuillez entrer vos informations professionnelles",
            employed_months: "Depuis combien de temps êtes-vous à cet emploi ?",
            pay_frequency: "À quelle fréquence êtes-vous payé ?",
            pay_date1: "Quelle est votre prochaine date de paiement ?",
            flinks_personal_loan: "Sélectionnez le compte bancaire sur lequel vous souhaitez que votre argent soit déposé",
            flinks_car_loan: 'Sélectionnez le compte bancaire que vous souhaitez utiliser pour vos paiements',
            flinks_powersports: 'Sélectionnez le compte bancaire que vous souhaitez utiliser pour vos paiements',
            how_to_contact: "Comment pouvons-nous vous joindre ?",
            phone_verification: 'Vérification du téléphone',
            lets_create_your_account: 'Créons votre compte !',
            create_comparehub_account: 'Voulez-vous créer un compte chez nous ?',
            citizen_status: 'Sélectionnez votre statut de citoyenneté',
            credit_card_debt_amount: 'Montant de la dette de carte de crédit',
            is_last_step: 'C\'est la dernière étape !',
            wants_equifax_verification: 'Voulez-vous être vérifié avec Equifax pour obtenir votre cote de crédit et votre rapport GRATUITS ?',
            confirm_information: 'Veuillez confirmer vos informations ci-dessous avant de continuer',
            sms_verification: 'Veuillez confirmer votre numéro de téléphone avec le code de vérification qui sera envoyé à votre téléphone',
            lets_get_you_approved: "Faites-vous approuver !",
            postal_code: 'Entrez votre code postal',

            // car loan application
            car_request_type: 'Sélectionnez le type de voiture que vous souhaitez acheter',
            car_request_monthly_budget: "Quel est votre budget mensuel ?",
            car_in_credit_situation: "Quelle est votre cote de crédit estimée ?",
            car_request_sms_verification_code: "Veuillez vérifier votre préférence de véhicule en demandant un code de vérification par SMS",

            // life insurance
            requested_amount_life_insurance: 'Quel montant de couverture désirez-vous?',
            what_province: 'Dans quelle province habitez-vous?',
            select_gender: 'Sélectionnez votre genre',
            title_salutation: 'Salutation',
            what_is_your_name: 'Quel est votre nom?',

            // powersports
            what_are_you_looking_for: "Qu'est-ce que vous souhaitez acheter ?",
            requested_amount_powersports: 'Quelle est la valeur de l\'article que vous souhaitez financer ?',

            // business loan
            business_start_date: 'Date de création de l\'entreprise',
            equity: 'Équité',
            business_assets: 'Actifs de l\'entreprise',
            company_information: 'Informations sur l\'entreprise',
            notice_of_assessment: 'Avis de cotisation (NOA)',
        },
        textTop: {
            hard_credit_check: `<div class="col-md-12 py-2" style="margin-top:30px;">Pour maximiser vos chances de trouver un prestataire de services, nous vous recommandons d'autoriser notre réseau de fournisseurs à obtenir des rapports de crédit auprès des agences d'évaluation du crédit pour évaluer votre historique de crédit et prendre des décisions d'approbation. En sélectionnant "<b class="text-secondary">Maximiser mes chances d'approbation</b>" le(s) fournisseur(s) correspondant(s) peuvent consulter votre rapport de crédit pour prendre des décisions d'approbation complètes basées sur votre demande et vous pouvez être financé plus rapidement. Sinon, vous acceptez que votre consentement se limite uniquement à une vérification de crédit souple et que vous limitez vos opportunités d'approbation. Votre consentement est valide jusqu'à ce que vous notifiiez au fournisseur correspondant le retrait de votre consentement.</div>`,
            unsecured_debt_amount_definition: `<p class="text-muted my-3 text-center">La dette non garantie fait référence aux prêts sur salaire ou personnels et aux factures de télécommunications, mais exclut les soldes de cartes de crédit, les prêts automobiles et les hypothèques.</p>`,
            create_comparehub_account_benefits: `
                <p>En créant un compte, vous pouvez :
                    <ul>
                        <li>Augmenter vos chances de qualification</li>
                        <li>Suivre l'historique de vos demandes</li>
                        <li>Accélérer les demandes futures</li>
                        <li><b>Obtenez votre cote de crédit Equifax gratuite !</b></li>
                    </ul>
                </p>
                <h6 class="text-center text-dark mt-3">La création de votre compte de cote de crédit gratuite n'affectera pas votre crédit</h6>
            `,
            get_options_with_consent: `<p class="text-muted h5 my-3 text-center">Êtes-vous prêt à recevoir vos recommandations par messages électroniques et à voir vos options de prêt ?</p>`,
            prequalify_best_providers: `<p class="text-muted h5" style="text-align: center;">Continuer nous aidera à vous préqualifier avec les meilleurs fournisseurs</p>`,
        },
        textBottom: {
            flinks_skip: '<div class="text-center col-md-12 py-2" style="margin-top: 30px;"><b class="text-primary">Important:</b> Vous pouvez ignorer cette étape en appuyant sur le bouton ci-dessous, cependant vos chances d"approbation peuvent être impactées.<br><br><small>En fournissant vos informations de connexion bancaire, vous confirmez que vous êtes conscient de toutes les obligations contractuelles avec votre institution financière.</small></div>',
            comparehub_member_pp_tc: `En créant un compte, vous deviendrez membre de CompareHub et aurez accès à des ressources éducatives, des recommandations personnalisées et la possibilité d'obtenir votre cote de crédit Equifax gratuite. Pour plus d'informations, veuillez consulter notre <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Politique de confidentialité</a> et nos <a href="https://loanscanada.ca/terms/" target="_blank">Conditions d'utilisation</a>. Cela n'affecte pas votre cote de crédit.`,
            create_comparehub_account_opt_in: `<p class="text-muted small">En créant un compte, vous deviendrez membre de CompareHub et aurez accès à des ressources éducatives, des recommandations personnalisées et la possibilité d'obtenir votre cote de crédit Equifax gratuite. Pour plus d'informations, veuillez consulter notre <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Politique de confidentialité</a> et nos <a href="https://loanscanada.ca/terms/" target="_blank">Conditions d'utilisation</a>. <b>Cela n'affecte pas votre cote de crédit.</b></p>`,
            consent_text: `<p class="text-muted text-center my-3"><small>En remplissant ce formulaire, j'autorise le fournisseur de services financiers de confiance avec lequel j'ai été jumelé à obtenir des rapports de crédit auprès des agences d'évaluation du crédit pour évaluer mon historique de crédit (cela n'affectera pas votre cote de crédit). Mon consentement est valide jusqu'à ce que j'informe le fournisseur correspondant de son retrait.</small></p>`,
            opt_in_text: `<p class="text-muted text-center my-3"><small>En sélectionnant 'Oui', vous acceptez de recevoir des promotions et des mises à jour de {brand} & CompareHub.</small></p>`,
        },
        textBottomBelowActionButtons: {
            credit_history_authorization_1: `
                <p class="text-center" style="font-size:13px; color:#aaa;">{credit_history_authorization_1}</p>
            `,
            credit_history_authorization_1_car_loan: `
                <p class="text-center" style="font-size:13px; color:#aaa;">{credit_history_authorization_1_car_loan}</p>
            `
        }
    },
    fields: {
        labels: {
            requested_amount: "Combien souhaitez-vous emprunter ?",
            rent_mortgage_payment: "Paiement du loyer/hypothèque",
            property_value: "Valeur de la propriété",
            property_mortgage: "Hypothèque de la propriété",
            first_name: "Prénom",
            last_name: "Nom de famille",
            email_address: "Courriel",
            confirm_email: 'Confirmez votre courriel',
            phone: 'Téléphone',
            phone_number: "Numéro de téléphone",
            employer_name: "Nom de l'employeur",
            job_title: "Profession",
            phone_number_work: "Téléphone professionnel",
            address_civic_number: "Numéro civique",
            address_street: "Rue",
            address_unit_number: "Numéro d'unité",
            address_postal_code: "Code postal",
            address_city: "Ville",
            address_province: "Province",
            password: 'Mot de passe',
            confirm_password: 'Confirmez votre mot de passe',
            dob: 'Quelle est votre date de naissance ?',
            sin_optional: 'NAS (Optionnel)',
            your_address: 'Votre adresse',
            answer_not_provided: "La réponse n'a pas été fournie.",
            monthly_income: 'Revenue mensuel',
            monthly_income_employment: 'Revenue mensuel d\'emploi',
            monthly_income_pension: 'Revenue mensuel de retraite',
            monthly_other_income: 'Autres revenus mensuels',
            postal_code: 'Code postal',
            province: 'Province',
            last_years_income: 'Revenu de l\'année dernière',
            year_before_last_income: 'Revenu de l\'année avant la dernière',
            liquid_equity: `Actifs liquides <br>(argent, actions, obligations, FNB)`,
            non_liquid_equity: `Actifs non liquides <br>(équipement, immobilier, véhicules)`,
            company_name: 'Nom de l\'entreprise',
            gross_sales_monthly: 'Ventes brutes (mensuelles)',
            gross_sales_cards: 'Ventes brutes (cartes seulement)',
            industry: 'Industrie',
            payment_processor: 'Quel est votre processeur de paiement ?'
        },
        options: {
            opt_yes: "Oui",
            opt_no: "Non",
            opt_not_right_now: "Pas maintenant",
            //requested_amount
            opt_1000_less: "1 000 $ ou moins",
            opt_1001_5000: "1 001 $ à 5 000 $",
            opt_5001_10000: "5 001 $ à 10 000 $",
            opt_10001_15000: "10 001 $ à 15 000 $",
            opt_15001_20000: "15 001 $ à 20 000 $",
            opt_20000_more: "Plus de 20 000 $",
            opt_20001_50000: "20 001 $ à 50 000 $",
            opt_50000_more: "Plus de 50 000 $",
            // product_purpose
            opt_debt_consolidation: "Consolidation de dettes",
            opt_cc_consolidation: "Consolidation de cartes de crédit",
            opt_emergency_expense: "Dépense d'urgence",
            opt_car_repair: "Réparation de voiture",
            opt_other: "Autre",
            // cc_debt_amount
            // unsecured_debt_amount
            opt_debt_amounts_5000_less: "Moins de 5 000 $",
            opt_debt_amounts_5001_10000: "5 001 $ à 10 000 $",
            opt_debt_amounts_10001_15000: "10 001 $ à 15 000 $",
            opt_debt_amounts_15001_20000: "15 001 $ à 20 000 $",
            opt_debt_amounts_20001_25000: "20 001 $ à 25 000 $",
            opt_debt_amounts_25000_more: "Plus de $25 000 $",
            // in_credit_situation
            opt_in_credit_situation_good: "Bonne (Plus de 700)",
            opt_in_credit_situation_fair: "Passable (550 - 700)",
            opt_in_credit_situation_low: "Faible (Moins de 550)",
            opt_in_credit_situation_cp: "Proposition de consommateur actuelle",
            opt_in_credit_situation_bk: "Faillite actuelle",
            opt_in_credit_situation_unknown: "Pas sûr",
            // income_type
            opt_income_type_full: "Temps plein",
            opt_income_type_part: "Temps partiel",
            opt_income_type_self: "Travailleur indépendant",
            opt_income_type_benefits: "Prestations familiales / AE",
            opt_income_type_disability: "Invalidité",
            opt_income_type_pension: "Pension / RPC / SV",
            opt_income_type_unemployed: "Sans emploi",
            opt_income_type_other: "Autre",
            //other income types
            opt_income_type_other_wsib: "CSPAAT",
            opt_income_type_other_short_term_disability: "Invalidité de courte durée",
            opt_income_type_other_long_term_disability: "Invalidité de longue durée",
            opt_income_type_other_social_security: "Assurance-emploi",
            opt_income_type_other_child_tax_benefit: "Allocation canadienne pour enfants",
            opt_income_type_other_rental_income: "Revenu locatif",
            opt_income_type_other_other: "Autre",
            opt_income_type_other_none: "Aucun",
            // monthly_income
            opt_1500_less: "1 500 $ ou moins",
            opt_1501_2000: "1 501 $ à 2000 $",
            opt_2001_3000: "2 001 $ à 3 000 $",
            opt_3001_4000: "3 001 $ à 4 000 $",
            opt_4001_5000: "4 001 $ à 5 000 $",
            opt_5000_more: "Plus de 5 000 $",
            // employed_months
            opt_employed_months_3_less: "Moins de 3 mois",
            opt_employed_months_3_6: "3 à 6 mois",
            opt_employed_months_6_12: "6 à 12 mois",
            opt_employed_months_12_more: "1 an ou plus",
            // pay_frequency
            opt_weekly: "Hebdomadaire",
            opt_bi_weekly: "Bi-hebdomadaire",
            opt_semi_monthly: "Semi-mensuel",
            opt_monthly: "Mensuel",
            // address_length_months
            opt_address_length_months_3_less: "Moins de 3 mois",
            opt_address_length_months_3_6: "3 à 6 mois",
            opt_address_length_months_6_12: "6 à 12 mois",
            opt_address_length_months_12_more: "1 an ou plus",
            // opt_in & credit consent
            opt_opt_in_consent: 'Recevoir des promotions et des mises à jour de {brand} par courriel. Vous pouvez vous désabonner à tout moment. En cliquant sur "Suivant", vous acceptez les <a href="https://loanscanada.ca/terms/" target="_blank">conditions d\'utilisation</a> et la <a href="https: //loanscanada.ca/privacy-policy/" target="_blank">politique de confidentialité</a>.',
            opt_opt_in_consent_by_lc: 'Recevoir des promotions et des mises à jour de {brand} par Loans Canada par courriel. Vous pouvez vous désabonner à tout moment. En cliquant sur "Suivant", vous acceptez les <a href="https://loanscanada.ca/terms/" target="_blank">conditions d\'utilisation</a> et la <a href="https: //loanscanada.ca/privacy-policy/" target="_blank">politique de confidentialité</a>.',
            opt_opt_in_consent_by_comparehub: 'Recevoir des promotions et des mises à jour de {brand} par CompareHub par courriel. Vous pouvez vous désabonner à tout moment. En cliquant sur "Suivant", vous acceptez les <a href="https://loanscanada.ca/terms/" target="_blank">conditions d\'utilisation</a> et la <a href="https: //loanscanada.ca/privacy-policy/" target="_blank">politique de confidentialité</a>.',
            opt_credit_auth_1: "Montrez-moi d'autres options",
            opt_credit_auth_2: "Maximisez mes chances d'approbation",
            // canadian status
            opt_cs_citizen: "Citoyen",
            opt_cs_permanent: "Résident permanent",
            opt_cs_work: "Permis de travail",
            opt_cs_student: "Visa étudiant",
            opt_cs_visitor: "Visiteur",
            opt_cs_other: "Autre",
            // options_opt_in
            opt_continue_with_consent_yes: "Oui, et montrez-moi mes options de prêt !",
            opt_continue_with_consent_no: "Continuez uniquement vers mes options de prêt",
            // car_request_type
            opt_car_type_sedan : 'Berline',
            opt_car_type_suv : 'VUS',
            opt_car_type_van : 'Minivan',
            opt_car_type_truck : 'Camion',
            // car_request_monthly_budget
            opt_car_budget_200_less : 'Jusqu\'à 200 $',
            opt_car_budget_201_350 : '201 $ à 350 $',
            opt_car_budget_351_500 : '351 $ à 500 $',
            opt_car_budget_501_more : '501 $ ou plus',
            // life insurance
            //requested_amount
            opt_100k_less: "100 000 $ ou moins",
            opt_100k_250k: "100 001 $ à 250 000 $",
            opt_250k_500k: "250 001 $ à 500 000 $",
            opt_500k_1m: "500 001 $ à 1 000 000 $",
            opt_1m_more: "Plus de 1 000 000 $",
            // title
            opt_title_male: "Homme",
            opt_title_female: "Femme",
            // powersports
            opt_powersports_rv: "Véhicules récréatifs",
            opt_powersports_boat: "Bateaux",
            opt_powersports_tractor: "Tracteurs de jardin",
            opt_powersports_atv: "VTT (véhicules tout-terrain)",
            opt_powersports_motorcycle: "Motocyclettes",
            opt_powersports_snowmobile: "Motoneiges",
            opt_powersports_ebike: "Vélos électriques",
            opt_powersports_personalwatercraft: 'Motomarines <span style="font-size: 0.75rem; display:block;">(p. ex., Jet Skis, Sea-Doos, bateaux)</span>',
            opt_powersports_camper: "Caravanes",
            opt_powersports_heavyequipment: "Équipements lourds",
            // business loan
            // - business_type
            opt_business_type_accounting: "COMPTABILITÉ",
            opt_business_type_agriculture: "AGRICULTURE",
            opt_business_type_animal_boarding: "PENSION POUR ANIMAUX",
            opt_business_type_apparel_accessories: "VÊTEMENTS ET ACCESSOIRES",
            opt_business_type_auto_dealership: "CONCESSIONNAIRE AUTOMOBILES",
            opt_business_type_auto_body: "CARROSSERIE",
            opt_business_type_auto_rental: "LOCATION D\'AUTOMOBILES",
            opt_business_type_beauty_barber: "SALON DE BEAUTÉ OU COIFFURE",
            opt_business_type_building_materials: "MATÉRIAUX DE CONSTRUCTION",
            opt_business_type_business_services: "SERVICES AUX ENTREPRISES",
            opt_business_type_car_wash: "LAVAGE DE VOITURE",
            opt_business_type_cellular_store: "MAGASIN DE CELLULAIRES",
            opt_business_type_child_education: "ÉDUCATION DES ENFANTS",
            opt_business_type_consulting: "CONSULTATION",
            opt_business_type_day_care: "SERVICE DE GARDERIE",
            opt_business_type_doctor: "MÉDECIN",
            opt_business_type_electronics_computers: "ÉLECTRONIQUE ET INFORMATIQUE",
            opt_business_type_entertainment: "ANIMATION",
            opt_business_type_equipment_rental: "LOCATION D\'ÉQUIPEMENTS",
            opt_business_type_fabrication: "FABRICATION",
            opt_business_type_financial_services: "SERVICES FINANCIERS",
            opt_business_type_franchise: "FRANCHISE",
            opt_business_type_funeral_home: "CENTRE FUNÉRAIRE",
            opt_business_type_gaming: "JEUX VIDÉOS",
            opt_business_type_gas_station: "STATION ESSENCE",
            opt_business_type_general_contractor: "ENTREPRENEUR GÉNÉRAL",
            opt_business_type_general_merchandise_store: "MAGASIN DE MARCHANDISES",
            opt_business_type_grocery_convenience_store: "ÉPICERIES ET DÉPANNEURS",
            opt_business_type_guns_ammunition_store: "MAGASIN D\'ARMES À FEUX",
            opt_business_type_gym_fitness_trainer: "ENTRAINEUR FITNESS",
            opt_business_type_health_services: "SERVICES DE SANTÉ",
            opt_business_type_home_furnishings: "AMEUBLEMENT",
            opt_business_type_hotel_motel: "HÔTEL / MOTEL",
            opt_business_type_hvac: "CVC (CHAUFFAGE, VENTILATION ET CLIMATISATION)",
            opt_business_type_insurance_brokers: "COURTIER EN ASSURANCES",
            opt_business_type_internet_retailer: "DÉTAILLANT INTERNET",
            opt_business_type_landscaping_services: "SERVICES D'AMÉNAGEMENT PAYSAGER",
            opt_business_type_laundry_garment_services: "SERVICES DE LAVERIE",
            opt_business_type_law_firm: "CABINET D'AVOCATS",
            opt_business_type_legal_counsel: "CONSEILLER JURIDIQUE",
            opt_business_type_locksmith: "SERRURIER",
            opt_business_type_manufacturing: "MANUFACTURIER",
            opt_business_type_marketing: "MARKETING",
            opt_business_type_media_production: "PRODUITS MÉDIATIQUES",
            opt_business_type_medical_healthcare: "SANTÉ PUBLIQUE",
            opt_business_type_nail_salon: "SALON DE MANUCURE",
            opt_business_type_oil_industry: "INDUSTRIE PÉTROLIÈRE",
            opt_business_type_other: "AUTRE",
            opt_business_type_photography_studio: "STUDIO PHOTOGRAPHIQUE",
            opt_business_type_pool_services: "SERVICES DE PISCINE",
            opt_business_type_printing: "IMPRIMERIE",
            opt_business_type_real_estate_related: "IMMOBILIER",
            opt_business_type_recreation: "LOISIRS",
            opt_business_type_residential_contractor: "ENTREPRENEUR IMMOBILIER",
            opt_business_type_restaurant_cafe_bar: "RESTAURANT, CAFÉ, BAR",
            opt_business_type_retail_store: "MAGASIN DE VENTE AU DÉTAIL",
            opt_business_type_sanitation: "ASSAINISSEMENT",
            opt_business_type_security_services: "SERVICES DE SÉCURITÉ",
            opt_business_type_senior_care_assisted_living: "SOINS DES AÎNÉS",
            opt_business_type_smoke_shop: "BUREAU DE TABAC",
            opt_business_type_solar: "ÉNERGIE SOLAIRE",
            opt_business_type_spa_services: "STATIONS THERMALES",
            opt_business_type_staffing: "RECRUTEMENT",
            opt_business_type_tanning_salon: "SALON DE BRONZAGE",
            opt_business_type_tax_preparation: "SERVICE DES IMPÔTS",
            opt_business_type_technology_company: "ENTREPRISE EN TECHNOLOGIE",
            opt_business_type_travel_transportation: "COMPAGNIE DE VOYAGE",
            opt_business_type_uniform_supplier: "FABRICANT D\'UNIFORMES",
            opt_business_type_veterinary_clinic: "CLINIQUE VÉTÉRINAIRE",
            opt_business_type_waste_management: "TRAITEMENT DES DÉCHETS",
            opt_business_type_wholesaler: "GROSSISTE",
            opt_business_type_wine_liquor_store: "MAGASIN D\'ALCOOL",
            // - payment_processor
            opt_business_payment_processor_chase_paymentech: "CHASE PAYMENTECH",
            opt_business_payment_processor_debitech: "DEBITECH",
            opt_business_payment_processor_desjardins: "DESJARDINS",
            opt_business_payment_processor_elavon: "ELAVON",
            opt_business_payment_processor_everlink: "EVERLINK",
            opt_business_payment_processor_first_data: "FIRST DATA",
            opt_business_payment_processor_global_payments: "GLOBAL PAYMENTS",
            opt_business_payment_processor_mercury_payments: "MERCURY PAYMENTS",
            opt_business_payment_processor_moneris: "MONERIS",
            opt_business_payment_processor_monex: "MONEX",
            opt_business_payment_processor_payfirma: "PAYFIRMA",
            opt_business_payment_processor_pivotal_payments: "PIVOTAL PAYMENTS",
            opt_business_payment_processor_pos_west: "POS WEST",
            opt_business_payment_processor_square: "SQUARE",
            opt_business_payment_processor_stripe: "STRIPE",
            opt_business_payment_processor_td_merchant_services: "TD MERCHANT SERVICES",
            opt_business_payment_processor_other: "AUTRE",
            opt_business_payment_processor_none: "AUCUN",
        },
        placeholders: {
            select: "Sélectionner…",
            your_email: "votre@courriel.com",
            income_type: "Sélectionnez votre principale source de revenus…",
            income_type_other: "Autre (précisez)",
            type_to_search: "Tapez pour rechercher…",
            address_number: "Numéro",
            address_street: "Rue",
            address_unit: "Apt 8, Suite 2, etc. (facultatif)",
            address_city: "Ville",
            select_date: "Sélectionner une date..."
        },
        textBottom: {
            phone_number_sms_results: '<small style="display: block; font-size: 0.7em; padding-left: 2px; margin-top: -14px;">Vous recevrez un unique SMS avec vos résultats ( répondez "STOP" pour arrêter ).</small>'
        }
    },
    buttons: {
        submit: 'Soumettre',
        skip: "Passer",
        address_not_listed: "Mon adresse ne figure pas dans la liste",
        next: 'Suivant',
        request_code: 'Demander un code',
        request_another_code: 'Demander un autre code',
        edit: 'Modifier'
    }
}
